/* eslint-disable no-console */
import axios from 'axios';
import moment from 'moment';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import useUserStore from '../../../store/userStore/userStore';
import {APIType, APITypeEnum} from '../../interface/tableAPIType';
import {getRouteIP, tableAPIMethod} from '../../utils/tableAPIMethod';

import {VehicleKey} from './../../../components/Forms/Constants/IP/VehicleKeyLabel';

const vehicleAPI = async (
  type: APIType,
  data: any = undefined,
  id: string = ''
): Promise<any> => {
  const token = useUserStore.getState().userToken;

  try {
    const response = await axios.request({
      method: tableAPIMethod(type),
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.vehicle}/${getRouteIP(
        type,
        id
      )}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: data ?? {}
    });
    if (type === APITypeEnum.GET_ALL) {
      return response.data.data.map((item: any) => {
        return {
          ...item,
          [VehicleKey.RENTED_FROM]: item?.[VehicleKey.RENTED_FROM]
            ? moment(item?.[VehicleKey.RENTED_FROM])
            : undefined,
          [VehicleKey.RENTED_TO]: item?.[VehicleKey.RENTED_TO]
            ? moment(item?.[VehicleKey.RENTED_TO])
            : undefined
        };
      });
    } else {
      return response.data;
    }
  } catch (err) {
    console.log('err:', err);
  }
};

export default vehicleAPI;
